import type { IconData } from '@stacksjs/iconify-core'

export const tr1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#e30a17\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M348.8 264c0 70.6-58.3 127.9-130.1 127.9s-130.1-57.3-130.1-128s58.2-127.8 130-127.8S348.9 193.3 348.9 264z\"/><path fill=\"#e30a17\" d=\"M355.3 264c0 56.5-46.6 102.3-104.1 102.3s-104-45.8-104-102.3s46.5-102.3 104-102.3s104 45.8 104 102.3z\"/><path fill=\"#fff\" d=\"m374.1 204.2l-1 47.3l-44.2 12l43.5 15.5l-1 43.3l28.3-33.8l42.9 14.8l-24.8-36.3l30.2-36.1l-46.4 12.8z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default tr1x1
